<template>
    <div class="site-config-management">
        <a-card title="网站基本配置" class="config-card">
            <template #extra>
                <a-button type="primary" @click="saveConfig" :loading="saving">
                    <SaveOutlined />
                    保存配置
                </a-button>
            </template>

            <a-form :model="siteConfig" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-form-item label="网站标题" name="title">
                    <a-input v-model:value="siteConfig.title" placeholder="网站标题" />
                </a-form-item>
                <a-form-item label="网站描述" name="description">
                    <a-textarea v-model:value="siteConfig.description" placeholder="网站描述" :rows="3" />
                </a-form-item>
                <a-form-item label="网站Logo" name="logo">
                    <FileUpload v-model:value="siteConfig.logo" category="siteBackground" placeholder="请输入Logo URL或点击上传"
                        default-mode="url" />
                </a-form-item>
                <a-form-item label="背景类型" name="backgroundType">
                    <a-radio-group v-model:value="siteConfig.backgroundType">
                        <a-radio value="image">图片背景</a-radio>
                        <a-radio value="video">视频背景</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :label="siteConfig.backgroundType === 'video' ? '背景视频' : '背景图片'" name="backgroundUrl">
                    <FileUpload v-model:value="siteConfig.backgroundUrl" category="siteBackground"
                        :placeholder="siteConfig.backgroundType === 'video' ? '请输入视频URL或点击上传' : '请输入图片URL或点击上传'"
                        default-mode="url" />
                </a-form-item>
            </a-form>
        </a-card>

        <!-- 背景预览 -->
        <a-card title="背景预览" class="preview-card" v-if="siteConfig.backgroundUrl">
            <div class="background-preview">
                <div v-if="siteConfig.backgroundType === 'image'" class="image-preview">
                    <img :src="siteConfig.backgroundUrl" alt="背景预览" />
                </div>
                <div v-else-if="siteConfig.backgroundType === 'video'" class="video-preview">
                    <video :src="siteConfig.backgroundUrl" muted loop autoplay>
                        您的浏览器不支持视频播放
                    </video>
                </div>
            </div>
        </a-card>
    </div>
</template>

<script>
import { reactive, ref, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import { Card, Form, Input, Button, Radio } from 'ant-design-vue'
import { SaveOutlined } from '@ant-design/icons-vue'
import FileUpload from '../FileUpload.vue'
import supabaseSystemConfigService from '../../services/supabaseSystemConfigService'

export default {
    name: 'SiteConfigManagement',
    components: {
        'a-card': Card,
        'a-form': Form,
        'a-form-item': Form.Item,
        'a-input': Input,
        'a-textarea': Input.TextArea,
        'a-button': Button,
        'a-radio-group': Radio.Group,
        'a-radio': Radio,
        SaveOutlined,
        FileUpload
    },
    setup() {
        const saving = ref(false)

        const siteConfig = reactive({
            title: '',
            description: '',
            logo: '',
            backgroundType: 'image',
            backgroundUrl: ''
        })

        // 加载配置
        const loadConfig = async () => {
            try {
                const config = await supabaseSystemConfigService.getConfigValue('site.config', {})

                if (config.title) {
                    siteConfig.title = config.title
                }
                if (config.description) {
                    siteConfig.description = config.description
                }
                if (config.logo) {
                    siteConfig.logo = config.logo
                }
                if (config.backgroundType) {
                    siteConfig.backgroundType = config.backgroundType
                }
                if (config.backgroundUrl) {
                    siteConfig.backgroundUrl = config.backgroundUrl
                }

                console.log('网站配置加载成功:', config)
            } catch (error) {
                console.error('加载网站配置失败:', error)
                message.error('加载网站配置失败')
            }
        }

        // 保存配置
        const saveConfig = async () => {
            try {
                saving.value = true

                // 将整个网站配置保存为一个JSON对象
                await supabaseSystemConfigService.setConfig(
                    'site.config',
                    siteConfig,
                    'user',
                    '网站基本配置'
                )

                message.success('网站配置保存成功')
            } catch (error) {
                console.error('保存网站配置失败:', error)
                message.error('保存网站配置失败')
            } finally {
                saving.value = false
            }
        }

        onMounted(() => {
            loadConfig()
        })

        return {
            saving,
            siteConfig,
            saveConfig
        }
    }
}
</script>

<style scoped>
.site-config-management {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.config-card,
.preview-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.config-card :deep(.ant-card-head-title),
.preview-card :deep(.ant-card-head-title) {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
}

.background-preview {
    max-width: 100%;
    border-radius: 8px;
    overflow: hidden;
    background: #f5f5f5;
}

.image-preview img {
    width: 100%;
    max-height: 300px;
    object-fit: cover;
    display: block;
}

.video-preview video {
    width: 100%;
    max-height: 300px;
    object-fit: cover;
    display: block;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .config-card :deep(.ant-form-item-label) {
        text-align: left;
    }

    .config-card :deep(.ant-col-6) {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .config-card :deep(.ant-col-18) {
        flex: 0 0 100%;
        max-width: 100%;
    }
}
</style>